module.exports = __webpack_public_path__ + "static/media/cyclelogos_taskList.e856304e.svg";